import { useState } from 'react'
import Icon from '../Icon'
import Button from '../Buttons'

import {
  Wrapper,
  InputBlock,
  LeftBlock,
  RightBlock
} from './styles'

interface Props {
  value?: string;
  onChange?: (any?: any) => any;
  leftItem?: React.ReactElement;
  rightItem?: React.ReactElement;
  height?: string;
  hasLeftIcon?: boolean;
  hasRightIcon?: boolean;
  leftElement?: React.ReactElement;
  rightElement?: React.ReactElement;
  placeholder?: string;
  hasError?: boolean;
  disable?: boolean;
  name?: string;
}

export default function Input({ value, onChange, height, leftItem, rightItem, hasLeftIcon, hasRightIcon, leftElement, rightElement, hasError, name, ...props }: Props) {

  const [hover, setHover] = useState(false)

  let classes = []
  if (height) classes.push(height)
  if (hasLeftIcon) classes.push(hasLeftIcon)
  if (hasRightIcon) classes.push(hasRightIcon)
  if (rightElement) classes.push('rightElement')
  if (leftElement) classes.push('leftElement')

  return (
    <Wrapper className={classes.join(' ')}>
      {/* {leftItem} */}
      {/* <LeftBlock><Icon autoplay={hover} playAnimation={hover} name="check" style={{width: '2.4rem'}} /></LeftBlock> */}
      {leftElement &&
        <LeftBlock>{leftElement}</LeftBlock>
      }
      <InputBlock
        value={value}
        onChange={onChange}
        onFocus={(e: any) => {setHover(true)}}
        onBlur={(e: any) => {setHover(false)}}
        className={hasError ? 'error' : null}
        {...props}
      />
      {/* {rightItem} */}
      {rightElement &&
        <RightBlock>{rightElement}</RightBlock>
      }
    </Wrapper>
  );
}